module.exports = __webpack_public_path__ + "img/section14.d046aa21.png";